import React from 'react'
import Flex from 'components/Flex'
import Avatar from 'components/Avatar'
import {
  InfoSection,
  CompanyName,
  DomainName,
} from 'modules/Drive/Partials/DrivesInfoTable/Partials/CompanyInfo/Style/style'

const CompanyInfo = ({ data }) => {
  return (
    <Flex alignVertically>
      <Avatar
        background
        src={''}
        size={36}
        IconName={data?.name?.split('')?.[0] || 'H'}
        font={18}
      />
      <InfoSection>
        <CompanyName>{data?.name}</CompanyName>
        <DomainName>{data?.industry}</DomainName>
      </InfoSection>
    </Flex>
  )
}

export default CompanyInfo
